import { render } from "./DownloadApp.vue?vue&type=template&id=41cd2bef&scoped=true"
import script from "./DownloadApp.vue?vue&type=script&lang=js"
export * from "./DownloadApp.vue?vue&type=script&lang=js"

import "./DownloadApp.vue?vue&type=style&index=0&id=41cd2bef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cd2bef"]])

export default __exports__